export default "__VITE_ASSET__0d3518a9__"